import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Popular routes to prefetch
const PREFETCH_ROUTES = ['/food', '/taxi', '/profile', '/delivery', '/cart'];

// Prefetch a route's chunk
const prefetchRoute = (path: string) => {
  const link = document.createElement('link');
  link.rel = 'prefetch';
  link.href = path;
  link.as = 'document';
  document.head.appendChild(link);
};

// Hook to prefetch routes based on user behavior
export const usePrefetchRoutes = () => {
  const location = useLocation();

  useEffect(() => {
    // Prefetch popular routes after initial load
    const timer = setTimeout(() => {
      PREFETCH_ROUTES.forEach(route => {
        if (route !== location.pathname) {
          prefetchRoute(route);
        }
      });
    }, 2000); // Wait 2s after page load

    return () => clearTimeout(timer);
  }, []);

  // Prefetch on link hover
  const prefetchOnHover = (path: string) => {
    if (!PREFETCH_ROUTES.includes(path)) return;
    prefetchRoute(path);
  };

  return { prefetchOnHover };
};

// Prefetch specific chunks for routes
export const prefetchChunks = {
  maps: () => import('@/components/lazy/LazyMaps'),
  charts: () => import('@/components/lazy/LazyCharts'),
};

// Preload critical resources
export const preloadCriticalResources = () => {
  // Preload Supabase client
  import('@/integrations/supabase/client');
  
  // Preload auth context
  import('@/contexts/AuthContext');
};
